import { makeStyles, TableCell, TableRow } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { ClientBillingReportDisplay } from "../../Types/ClientBilling";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
}));

export default function BillingReportCell({
  columns,
  element,
  index,
}: TableRowProps<ClientBillingReportDisplay>) {
  const classes = useStyles();
  const history = useHistory();
  return (
    <TableRow
      role="link"
      hover
      className={index % 2 ? classes.rowCell : classes.rowCellOdd}
      key={index}
      onClick={() => history.push({ pathname: "/billingreports/billingdetails", state: element })}
    >
      {columns.map((column, elementIndex) => (
        <TableCell align="left" key={elementIndex}>
          {element[column.propName]}
        </TableCell>
      ))}
    </TableRow>
  );
}
